import styled from 'styled-components';
import { Content } from '../../../theme/layout';
import { H2, spacedHeading } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { DatePicker } from './datePicker';

export const Container = styled(Content)`
  display: grid;
  grid-column-gap: 56px;
  grid-row-gap: 56px;
  grid-template-columns: 1fr;
  grid-template-areas:
    'calendar'
    'timeslots';
  ${media.tablet`
    grid-template-columns: 438px 1fr;
    grid-template-areas: 'calendar timeslots'
  `}
  ${media.desktop`
    padding-left: 152px;
    grid-column-gap: 152px;
  `};
`;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-bottom: 24px;

  ${media.tablet`
    margin-bottom: 56px;
  `}
`;

export const CalendarWrapper = styled.div`
  grid-area: calendar;
`;

export const Calendar = styled(DatePicker)``;

export const TimeSlotsWrapper = styled.div`
  grid-area: timeslots;
`;
